import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { RoleApi } from 'api';
import { CreateRoleType, RoleScope } from 'types';

function useCreate() {
  const queryClient = useQueryClient();
  return useAuthMutation(
    ({ scope, ...data }: CreateRoleType & { scope: RoleScope }) =>
      RoleApi.post(scope, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
      },
    },
  );
}

export default useCreate;
